import React from 'react';
import { Link } from 'react-router-dom';
import logosvg from 'assets/logo_secondary.svg';
import logowhats from 'assets/whatsapp_default.svg';
import { FaLongArrowAltRight } from 'react-icons/fa';
import { Container, Row, Navbar, Col } from 'react-bootstrap';
import { analytics } from 'config/firebase';
import {
  Header,
  ColRight,
  ColLeft,
  NavLink,
  BackgroundHeader,
  LegendImg,
  BG,
  ButtonCardapio,
} from './styles';

const HomeHader = () => {
  return (
    <BackgroundHeader>
      <BG>
        <Navbar>
          <Container>
            <Row className="w-100 align-items-center">
              <Col xs={12} sm={6} lg={8} xl={7} className="text-center text-sm-left">
                <Navbar.Brand href="/">
                  <img alt="" src={logosvg} height={100} className="d-inline-block align-top" />
                </Navbar.Brand>
              </Col>
              <Col xs={12} sm={6} lg={4} xl={5} className="text-center text-lg-left">
                <NavLink
                  href="https://wa.me/558896089633"
                  target="_blank"
                  without="true"
                  title="Whatsapp"
                  rel="noopener noreferrer"
                >
                  <img
                    alt=""
                    src={logowhats}
                    height={40}
                    fill="#fff"
                    className="d-inline-block mr-2"
                  />
                  <small>ENVIAR MENSAGEM</small>
                </NavLink>
              </Col>
            </Row>
          </Container>
        </Navbar>
        <Container>
          <Header className="w-100 h-100">
            <Row className="align-items-center">
              <ColLeft xs={12} lg={7}>
                <p>
                  Self-Service Saborear e Restaurante possuem um amplo cardápio, com comidas e
                  bebidas diferenciadas, feitas com os melhores ingredientes, pratos bem servidos e
                  ambiente aconchegante.
                </p>
                <Row>
                  <Col xs={8} sm={7} lg={6}>
                    <Link
                      component={ButtonCardapio}
                      to="/pedido"
                      className="btn-labeled"
                      onClick={() => {
                        analytics.logEvent('home_pedido_btn_click');
                      }}
                    >
                      FAZER PEDIDO
                      <span>
                        <FaLongArrowAltRight />
                      </span>
                    </Link>
                  </Col>
                </Row>
              </ColLeft>
              <ColRight xs={12} lg={5} className="text-lg-left text-center p-3">
                <img className="img-fluid" src="assets/carne/carneprato.png" alt="carne no prato" />
                <LegendImg className="text-lg-right">&quot;Saboreie sem moderação&quot;</LegendImg>
              </ColRight>
            </Row>
          </Header>
        </Container>
      </BG>
    </BackgroundHeader>
  );
};

export default HomeHader;
